import React from 'react';
import { CheckIcon, DollarSignIcon, MapIcon, LandmarkIcon } from 'lucide-react';
export function KeyHighlights() {
  return <section className="py-24 px-6 bg-[#F5F0E8]" data-id="element-33">
      <div className="max-w-7xl mx-auto" data-id="element-34">
        <div className="text-center mb-16" data-id="element-35">
          <span className="text-[#1E3D2F] text-sm tracking-[0.2em] uppercase font-semibold" data-id="element-36">
            Investment Summary
          </span>
          <h2 className="text-4xl md:text-5xl text-[#1E3D2F] mt-4 mb-6" data-id="element-37">
            Key Highlights
          </h2>
          <div className="h-1 w-20 bg-[#C9B99A] mx-auto" data-id="element-38" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-39">
          {/* Highlight 1 */}
          <div className="bg-white p-10 shadow-sm border-t-4 border-[#1E3D2F] hover:-translate-y-1 transition-transform duration-300" data-id="element-40">
            <div className="h-12 w-12 bg-[#1E3D2F]/5 rounded-full flex items-center justify-center mb-6" data-id="element-41">
              <MapIcon className="h-6 w-6 text-[#1E3D2F]" data-id="element-42" />
            </div>
            <h3 className="text-2xl text-[#1E3D2F] mb-4 font-medium" data-id="element-43">
              GRZ Corner Site
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-44">
              Prime General Residential Zone (GRZ) corner allotment offering
              flexibility for future development or renovation (STCA).
            </p>
          </div>

          {/* Highlight 2 */}
          <div className="bg-white p-10 shadow-sm border-t-4 border-[#C9B99A] hover:-translate-y-1 transition-transform duration-300" data-id="element-45">
            <div className="h-12 w-12 bg-[#C9B99A]/10 rounded-full flex items-center justify-center mb-6" data-id="element-46">
              <DollarSignIcon className="h-6 w-6 text-[#C9B99A]" data-id="element-47" />
            </div>
            <h3 className="text-2xl text-[#1E3D2F] mb-4 font-medium" data-id="element-48">
              $330,000* Income
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-49">
              Substantial holding income of approximately $330,000 per annum*,
              providing strong returns while planning future outcomes.
            </p>
          </div>

          {/* Highlight 3 */}
          <div className="bg-white p-10 shadow-sm border-t-4 border-[#1E3D2F] hover:-translate-y-1 transition-transform duration-300" data-id="element-50">
            <div className="h-12 w-12 bg-[#1E3D2F]/5 rounded-full flex items-center justify-center mb-6" data-id="element-51">
              <LandmarkIcon className="h-6 w-6 text-[#1E3D2F]" data-id="element-52" />
            </div>
            <h3 className="text-2xl text-[#1E3D2F] mb-4 font-medium" data-id="element-53">
              Prestigious Location
            </h3>
            <p className="text-gray-600 leading-relaxed" data-id="element-54">
              Situated directly opposite Loreto Mandeville Hall, in one of
              Melbourne's most coveted educational and residential precincts.
            </p>
          </div>
        </div>
      </div>
    </section>;
}